module.exports = __webpack_public_path__ + "img/pet_story.904f40f4.png";